import { render, staticRenderFns } from "./AlertSettingStoreGroupSetting.vue?vue&type=template&id=0c1da8e8&scoped=true&"
import script from "./AlertSettingStoreGroupSetting.vue?vue&type=script&lang=ts&"
export * from "./AlertSettingStoreGroupSetting.vue?vue&type=script&lang=ts&"
import style0 from "./AlertSettingStoreGroupSetting.vue?vue&type=style&index=0&id=0c1da8e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1da8e8",
  null
  
)

export default component.exports